import React from "react";

function UiContainer({
  children,
  as,
  className = "bg-white",
}: {
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
}) {
  const Component = as || "div";
  return <Component className={`  ${className} `}>{children}</Component>;
}

export default UiContainer;
